import { get } from 'lodash';

class APIError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

export function handleResponse(res, throwError = true) {
  if (res.errorObject) {
    const error = new APIError(res.errorObject.message, res.status, res.data);
    if (throwError) {
      throw error;
    }
    return error;
  }
  return {
    data: get(res, 'data.data'),
    code: get(res, 'data.code'),
    status: get(res, 'status'),
    message: get(res, 'data.message'),
  };
}

export function transformResponse(response) {
  try {
    const parsedResponse = JSON.parse(response);
    const responseData = get(parsedResponse, 'data', []);
    return responseData;
  } catch (error) {
    throw new Error('Failed to parse response');
  }
}

export function transformResponseListData(response) {}
